import React from 'react'
import InputNumber from './input-number'

type Props = {
  className?: string
}

const InputQuantity = (props: Props) => {
  return (
    <div className="card__quantity font-bold text-black items-center leading-normal  flex flex-row pb-2 ">
      <div className="py-2 flex pr-2">
        <div className="text-right font-bold whitespace-nowrap">
          Quantity:
        </div>
      </div>

      <div className="card__quantity__items ">
        <div className="mb-2 mt-2 ">
          <InputNumber
            name={"quantity"}
          />
        </div>
      </div>
    </div>

  )
}

export default InputQuantity